import React from 'react';
import merge from 'lodash/merge';
import {PremiumWrapperOverlay} from '../../PremiumWrapperOverlay';
import {Col, Form, Row} from 'react-bootstrap';
import {Action} from '../../../system/buttons';
import {AlanWakeWidgetProps} from '@pulsoid-private/widgets-lib';
import Ranges from '../../../system/ranges';
import ColorPicker from './ColorPicker';

const DEFAULT_CONFIG: AlanWakeWidgetProps['configuration'] = {
  ranges: [
    {
      from: 0,
      to: 75,
      color: '#6DAAB5',
    },
    {
      from: 76,
      to: 85,
      color: '#7CA372',
    },
    {
      from: 86,
      to: 105,
      color: '#C4C164',
    },
    {
      from: 105,
      to: 999,
      color: '#B26969',
    },
  ],
};

export const AlanWakeWidgetEdit = (props) => {
  const [configuration, setConfiguration] = React.useState<
    AlanWakeWidgetProps['configuration']
  >(merge({}, DEFAULT_CONFIG, props.configuration));

  const updateConfiguration = (configPart: Partial<typeof DEFAULT_CONFIG>) => {
    const newConfiguration = {...configuration, ...configPart};
    setConfiguration(newConfiguration);
    props.onUpdate(newConfiguration);
  };

  const handleOnSave = () => {
    props.onSave(configuration);
  };

  return (
    <>
      <PremiumWrapperOverlay
        bi={{
          from: 'widget_edit_premium_update',
          id: props.id,
        }}
        disabled={!props.premiumUpdate}
      >
        <Form.Group as={Row}>
          <Form.Label column htmlFor="bar-animation" sm="2">
            Animate Bar
          </Form.Label>
          <Col sm="3">
            <Form.Switch
              style={{marginTop: 7}}
              id="bar-animation"
              defaultChecked={configuration.animatedActivityBar}
              onChange={(e) =>
                updateConfiguration({
                  animatedActivityBar: e.currentTarget.checked,
                })
              }
            />
          </Col>
        </Form.Group>
        <Form.Group as={Row}>
          <Form.Label column htmlFor="heart-animation" sm="2">
            Animate Heart
          </Form.Label>
          <Col sm="3">
            <Form.Switch
              style={{marginTop: 7}}
              id="heart-animation"
              defaultChecked={configuration.animatedHeart}
              onChange={(e) =>
                updateConfiguration({
                  animatedHeart: e.currentTarget.checked,
                })
              }
            />
          </Col>
        </Form.Group>

        <Form.Group>
          <Ranges
            keepLength
            ranges={configuration.ranges}
            onRangesChange={(ranges) => updateConfiguration({ranges})}
            header={
              <Col md={3}>
                <Form inline>
                  <Col>Color</Col>
                </Form>
              </Col>
            }
            rangeConfiguration={(range, onRangeChange) => (
              <Col md={3} key={range.from}>
                <Row>
                  <Col>
                    <Form inline>
                      <ColorPicker
                        color={range.color}
                        onChangeComplete={(color) =>
                          onRangeChange({...range, color})
                        }
                      />
                    </Form>
                  </Col>
                </Row>
              </Col>
            )}
          />
        </Form.Group>
      </PremiumWrapperOverlay>

      <Action onClick={handleOnSave}>Save settings</Action>
    </>
  );
};
